import { useCallback, useRef } from 'react'

import B2becQuantity from '@/components/B2becQuantity'
import QUANTITY_TYPE from '@/components/B2becQuantity/constants'
import { useAppDispatch } from '@/store/hook'
import { setCartItemQuantity } from '@/store/slices/cartSlice'

interface CartItemQuantityWrapperProps {
  materialNumber: string
  quantity: number
  isParentDisabled?: boolean
  hasMinQuantity?: boolean
}

const CartItemQuantityWrapper = ({
  materialNumber,
  quantity,
  isParentDisabled,
  hasMinQuantity,
}: CartItemQuantityWrapperProps) => {
  const dispatch = useAppDispatch()
  const timeoutId = useRef<NodeJS.Timeout | null>(null)

  const handleChangeQuantity = useCallback(
    (materialNumber: string, newQuantity: number) => {
      clearTimeout(timeoutId.current)

      timeoutId.current = setTimeout(() => {
        if (newQuantity > 0) {
          dispatch(
            setCartItemQuantity({
              materialNumber,
              quantity: newQuantity,
            }),
          )
        }
      }, 280)
    },
    [dispatch],
  )

  return (
    <div className="cart-item-quantity-wrapper">
      <B2becQuantity
        hasMinQuantity={hasMinQuantity}
        initialQuantity={quantity}
        isParentDisabled={isParentDisabled}
        materialNumber={materialNumber}
        type={QUANTITY_TYPE.SHOPPING_CART}
        onChange={handleChangeQuantity}
      />
    </div>
  )
}

export default CartItemQuantityWrapper
